import React, { useState } from "react";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { to: "/",         label: "Home"     },
    { to: "/about",    label: "About"    },
    { to: "/services", label: "Services" },
    { to: "/contact",  label: "Contact"  },
  ];

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <nav className="navbar">
      {/* ── Logo ── */}
      <Link to="/" className="navbar-logo" onClick={scrollToTop}>
        <img src="/keystonelogo.png" alt="Keystone Insurance Brokers" />
      </Link>

      {/* ── Desktop links ── */}
      <div className="navbar-links">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={`nav-link ${pathname === l.to ? "active" : ""}`}
            onClick={scrollToTop}
          >
            {l.label}
          </Link>
        ))}
        <a href="tel:6045958666" className="nav-phone">
          <Phone size={14} />
          (604) 595-8666
        </a>
      </div>

      {/* ── Mobile hamburger ── */}
      <button
        className="navbar-hamburger"
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* ── Mobile drawer ── */}
      {menuOpen && (
        <div className="navbar-drawer">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`drawer-link ${pathname === l.to ? "active" : ""}`}
              onClick={() => {
                scrollToTop();
                setMenuOpen(false);
              }}
            >
              {l.label}
            </Link>
          ))}
          <a href="tel:6045958666" className="drawer-phone">
            <Phone size={14} /> (604) 595-8666
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;